import styled from 'styled-components';

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;

  ${({ theme }) => theme.max("sm")`
    align-items: flex-start;
  `}

  ${({ theme }) => theme.max("xs")`
    flex-direction: column;
  `}
`;

export const IconLabelGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
`;

export const Icon = styled.img`
  width: 16px;
  height: 16px;
`;

export const Label = styled.span`
  color: var(--Generic-Black, #000);
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  white-space: nowrap;
  width: 108px;
`;